import { useEffect, useState } from 'react';
import { RouterProvider } from 'react-router-dom';
import { initPlausible } from '@/lib/analytics/plausible';
import { createRouter } from './router/routes';

export function App() {
  // Construit le router au premier render — APRÈS `registerFeatures()`
  // qui tourne dans `main.tsx` avant `createRoot().render()`. Sans `useState`
  // lazy, le module routes.tsx s'évaluerait à l'import (avant register).
  const [router] = useState(() => createRouter());
  // Le traceur a besoin de `router.routes` (arbre agrégé) pour réécrire les
  // adresses ; dans un effet, jamais pendant le rendu.
  useEffect(() => {
    initPlausible(router.routes);
  }, [router]);
  return <RouterProvider router={router} />;
}
